<template>
  <section class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" @onChangeCustomer="onChangeCustomer" />
      <Car ref="car" @calCostPrice="calCostPrice" :goodsType="goodsType" />
      <LineForm ref="line" @calCostPrice="calCostPrice" />
      <Income
        ref="income"
        @calCostPrice="calCostPrice"
        :priceEnumOptions="priceEnumOptions"
      />
      <Freight ref="freight" v-show="this.userInfo.customerType === '8'"/>
      <Cost ref="cost" />
      <CostOuter ref="costOuter" />
      <Settlement ref="settlement" :balanceTypeOptions="balanceTypeOptions" />
      <Other ref="other" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </section>
</template>

<script>
import BaseForm from './base';
import Car from './car';
import LineForm from './line';
import Income from './income';
import Freight from './freight';
import Cost from './cost';
import CostOuter from './costOuter';
import Settlement from './settlement';
import Other from './other';
import SubBtnBox from 'components/subBtnBox';
import pageDataMixin from '@qx/mixin/pageData';
import {
  customerLineEdit,
  customerLineDetail,
} from 'api/archives';
import {
  getEnumList,
} from 'api';
import { calCostPrice } from './calc';
import {mapState} from 'vuex';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Car,
    LineForm,
    Income,
    Freight,
    Cost,
    CostOuter,
    Settlement,
    Other,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/customer/line/edit',
      formComponents: ['baseForm', 'car', 'line', 'income', 'freight', 'cost', 'costOuter', 'settlement', 'other'],
      goodsType: [],
      priceEnumOptions: [], // 收入单价单位
      balanceTypeOptions: [], // 结算方式

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        lineId: '',
        lineName: '',
        lineTel: '',
        saleDaparment: '',
        state: '',
        effectBegin: '',
        effectEnd: '',
        customerLineNo: '',
        customerId: '',
        customerName: '',
        vehicleStatus: '',
        goodsWeight: '',
        goodsName: '',
        goodsType: '',
        goodsNumber: '',
        vehicleLength: '',
        goodsVolume: '',
        sourceAddress: '',
        sourceEand: '',
        sourceNand: '',
        sourceProvince: '',
        sourceCity: '',
        sourceCounty: '',
        navigatSourceLocation: '',
        subWayList: '',
        desAddress: '',
        desEand: '',
        desNand: '',
        desProvince: '',
        desCity: '',
        desCounty: '',
        navigatDesLocation: '',
        arriveTime: '',
        cmMileageNumber: '',
        mileageNumber: '',
        lineCodeName: '',
        taiwanDate: '',
        priceUnit: '',
        estimateIncome: '',
        priceEnum: '',
        oilCostPer: '',
        pontagePer: '',
        emptyOilCostPer: '',
        guidePrice: '',
        guideMerchant: '',
        payWay: '',
        reciveTime: '',
        reciveTimeDay: '',
        collectionTime: '',
        collectionTimeDay: '',
        remarks: '',
        customerType: '',
        fullFreight: '',
        projectSettlementPrice: '',
        settlementUnitPrice: '',
        goodsUnitPrice: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        lineId: this.$route.query.id,
        isEdit: 1,
      };
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息

    }),
  },
  methods: {
    detailApi: customerLineDetail,
    editApi: customerLineEdit,
    // 处理对比参数
    adjustCompareParams (compareParams) {
      if (compareParams.effectBegin) {
        compareParams.effectBegin = compareParams.effectBegin.split(' ')[0];
      }
      if (compareParams.effectEnd) {
        compareParams.effectEnd = compareParams.effectEnd.split(' ')[0];
      }
      if (compareParams.subWayList) {
        compareParams.subWayList = JSON.stringify(compareParams.subWayList);
      }
    },
    onChangeCustomer (data) {
      this.$refs.settlement.setValueFromCustomer(data);
    },
    calCostPrice () {
      calCostPrice({
        cmMileageForm: this.$refs.line,
        incomeForm: this.$refs.income,
        carriageForm: this.$refs.car,
      });
    },
  },
  async mounted () {
    const enums = await getEnumList({
      codeType: 'GOODS_TYPE,PRICE_ENUM,BALANCE_TYPE',
    });
    this.goodsType = enums[0];
    this.priceEnumOptions = enums[1]; // 收入单价单位
    this.balanceTypeOptions = enums[2]; // 结算方式
    this.$nextTick(async () => {
      await this.$refs.baseForm.getList();
      await this.$refs.car.getList();
      this.getData();
    });
  },
};
</script>

<style scoped lang="scss">
</style>
